const BKADMIN_EMAIL = "bkadmin@erp.astrophant.online";
const BKADMIN_MDM_AUTH_KEY = "57b2a9ba-4428-48e4-b137-f8337b68595e";
const DEFAULT_MDM_AUTH_KEY = "e3f49b87-3a1d-4c29-9c51-2f1b8f4c7ad3";

export function getMdmAuthKeyByEmail(email) {
  const normalizedEmail = typeof email === "string" ? email.trim().toLowerCase() : "";
  return normalizedEmail === BKADMIN_EMAIL ? BKADMIN_MDM_AUTH_KEY : DEFAULT_MDM_AUTH_KEY;
}
